export default __webpack_public_path__ + "static/Wallop-Light-259a26468e804d2ea592bcdad0c60c07.woff2";